import axios from "../../axios";
import { useMutation, useQuery } from "react-query"
import { route } from './routes';




export function useSellerServiceAreaUpdate() {
  return useMutation(async (payload) => {
    const { data } = await axios.post(route.SELLER_SERVICE_AREA_UPDATE, payload);
    return data;
  })
}


export function useSellerTimingUpdate() {
  return useMutation(async (payload) => {
    const { data } = await axios.post(route.UPDATE_SELLER_SHOP_TIMING, payload);
    return data;
  })
}

export function useSellerShopOpenCloseHandler() {
  return useMutation(async (payload) => {
    const { data } = await axios.post(route.UPDATE_SELLER_SHOP_OPEN_CLOSE_STATE, payload);
    return data;
  })
}


// Update Seller Commission
export function useUpdateSellerCommission() {
  return useMutation(async (payload) => {
    const { data } = await axios.post(route.UPDATE_SELLER_COMMISSION, payload);
    return data;
  })
}

// seller List
export function useSellerList({ page, pageSize, search, status, product_type }) {
  return useQuery([route.GET_SELLER_LIST, page, pageSize, search, status, product_type], async () => {
    const { data } = await axios.get(route.GET_SELLER_LIST, {
      params: { page, pageSize, search, status, product_type }
    });
    return data;
  })
}

// seller Product List
export function useSellerProductList({ page, pageSize, search, seller_id }) {
  console.log('payload', page, pageSize, search, seller_id );
  return useQuery([route.GET_SELLER_PRODUCT_LIST, page, pageSize, search, seller_id ], async () => {
    const { data } = await axios.get(`${route.GET_SELLER_PRODUCT_LIST}/${seller_id}`, {
      params: { page, pageSize, search, seller_id }
    });
    return data;
  }, {
    enabled:seller_id==null?false:true
  });
}

export function useGetRecentAddedVendor({ limit }) {
  return useQuery([route.GET_RECENT_SELLER_LIST, limit], async () => {
    const { data } = await axios.get(route.GET_RECENT_SELLER_LIST, {
      params: { limit }
    });
    return data;
  })
}

export function useSellerReviews({ seller_id }) {
  return useQuery([route.GET_SELLER_ORDER_REVIEWS, seller_id], async () => {
    const { data } = await axios.get(route.GET_SELLER_ORDER_REVIEWS, {
      params: { seller_id }
    });
    return data;
  }, {
    enabled:seller_id?true:false
  })
}

// Seller Transections ===========================================================

export function useSellerTotalSale({ id }) {
  return useQuery([route.SELLER_TOTAL_SALE_AMOUNT, id], async () => {
    const { data } = await axios.get(`${route.SELLER_TOTAL_SALE_AMOUNT}/${id}`);
    return data;
  }, {
    enabled:id?true:false
  })
}


export function useSellerTotalRevenue({ id }) {
  return useQuery([route.SELLER_TOTAL_REVENUE, id], async () => {
    const { data } = await axios.get(`${route.SELLER_TOTAL_REVENUE}/${id}`);
    return data;
  }, {
    enabled:id?true:false
  })
}


export function useSellerTotalPaidAmount({ id }) {
  return useQuery([route.SELLER_TOTAL_PAID_AMOUNT, id], async () => {
    const { data } = await axios.get(`${route.SELLER_TOTAL_PAID_AMOUNT}/${id}`);
    return data;
  }, {
    enabled:id?true:false
  })
}


export function useSellerTotalRemainingAmount({ id }) {
  return useQuery([route.SELLER_TOTAL_CURRENT_BALANCE_AMOUNT, id], async () => {
    const { data } = await axios.get(`${route.SELLER_TOTAL_CURRENT_BALANCE_AMOUNT}/${id}`);
    return data;
  }, {
    enabled:id?true:false
  })
}


// Transections
export function useSellerPaymentTransections({ id, page, pageSize }) {
  return useQuery([route.SELLER_TRANSECTION_LIST, id, page, pageSize], async () => {
    const { data } = await axios.get(`${route.SELLER_TRANSECTION_LIST}/${id}`, {
      params:{
        page, 
        pageSize
      }
    });
    return data;
  }, {
    enabled:id?true:false
  })
}


// Transections ===============
export function useSellerPayment() {
  return useMutation(async (payload) => {
    const { data } = await axios.post(route.SELLER_PAYMENT_PAY, payload);
    return data;
  })
}


// Adjust Balance
export function useSellerAdjust() {
  return useMutation(async (id) => {
    const { data } = await axios.get(`${route.SELLER_BALANCE_ADJUSTMENT}/${id}`);
    return data;
  })
}


// seller Details
export function useUpdateAllowFreeDelivery() {
  return useMutation(async (payload) => {
    const { data } = await axios.post(`${route.SELLER_FREE_DELIVERY_UPDATE}`, payload);
    return data;
  })
}